import fr from 'facet-rest';
import { GuidedHouseholdReviewLayoutHeader } from 'Components/UI/guidedHouseholdReview/layoutHeader';
import React from 'react';
import { FDBox } from '@facet-wealth/design';
import { RoadmapDeliverableNav } from './RoadmapDeliverableNav';

export function NavPicker({ resource }) {
  return resource.withRelationship(
    fr.relationships.guidedHouseholdReviewLayout.name,
    () => (
      <FDBox paddingX={4}>
        <FDBox padding={2} />
        <GuidedHouseholdReviewLayoutHeader hideTitle />
        <FDBox padding={1} />{/* We need less padding down here because of an FDStack below that's adding extra vertical padding that would make the page appear jumpy */}
      </FDBox>
    ),
    () => <RoadmapDeliverableNav navAwayRelationship={resource.relationship(fr.relationships.navigateAway.name)} />,
  );
}
